import api from 'common/api';

export const getCustomsClearanceRequestAPI = (params: any) => api.get('/customs-clearance-request/list', params);

export const getCustomsClearanceRequestDetailAPI = (params: any) =>
  api.get('/customs-clearance-request/detail', params);

export const getPicAPI = (params: any) => api.get('/customs-clearance-request/pic', params);

export const addCustomsClearanceRequestAPI = (params: any) => api.post('/customs-clearance-request', params);

export const updateCustomsClearanceRequestAPI = (params: any) => api.put('/customs-clearance-request', params);

export const deleteCustomsClearanceRequestAPI = (params: any) => api.put('/customs-clearance-request/delete', params);

export const updateDlCustomsClearanceRequestAPI = (params: any) =>
  api.post('/customs-clearance-request/update-dl', params);

export const getHolidayAPI = (params: any) => api.get('/customs-clearance-request/holiday-list', params);

export const uploadOutsideDocAPI = (params: any) => api.post('/customs-clearance-request/document-upload', params);

export const getCustomsClearanceRequestCalendarAPI = (params: any) =>
  api.get('/customs-clearance-request/calender-list', params);

export const foldFlagHblDisplayCalendarFlgAPI = (params: any) =>
  api.post('/customs-clearance-request/update-calendar-display-flg', params);

export const DOWNLOAD_CUST_CLEAR_REQ_FILE_API = '/customs-clearance-request/download';
